import React, { useEffect, useState } from 'react';
import LockerMenu from '../../Components/LockerMenu';
import { PageWrapper } from '../../Styles/style';
import Header from '../../Sections/S1-Header';
import EcoSystem from '../../Sections/S2-EcoSystem';
import Worldwide from '../../Sections/S3-WorldWide';
import Users from '../../Sections/S5-Users';
import Pricing from '../../Sections/S4-Pricing';
import { Box } from '@mui/material';
import styled from '@emotion/styled';
import layerbg from '../../../assets/layerbg.png';
import Partners from '../../Sections/S6-Partners';
import Footer from '../../Sections/S8-Footer';
import SmoothScroll from '../../Components/GsapSmoothScroll';
import LaunchBar from '../../Components/LaunchBar';

const LayerWrapper = styled(Box)`
  width: 100%;
  background-image: url(${layerbg});
  background-repeat: repeat;
  background-position: center;
  position: relative;
`;

const BlurOverlay = styled(Box)`
  position: absolute;
  top: -78px;
  width: 100%;
  height: 27%;
  background: linear-gradient(
    to top,
    rgba(245, 245, 245, 0) 0%,
    rgba(0, 0, 0, 0.212) 50%,
    #000000f0 100%
  );
  z-index: 2;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const MainContent = () => (
  <PageWrapper>
    {/* <LaunchBar /> */}
    <LockerMenu />
    <Header />
    <EcoSystem />
    <LayerWrapper>
      <Worldwide />
      <BlurOverlay />
      <Pricing />
      <Users />
    </LayerWrapper>
    <Partners />
    <Footer />
  </PageWrapper>
);

const MainPage = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      setIsDesktop(window.innerWidth > 1024);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return isDesktop ? (
    <SmoothScroll>
      <MainContent />
    </SmoothScroll>
  ) : (
    <MainContent />
  );
};

export default MainPage;
